import { FC } from 'react';
import { Box } from '@mui/material';
import cn from 'classnames';

import DetailsAtTop from '../DetailsAtTop/DetailsAtTop';

import MedicationInformationForm from './MedicationInformationForm/MedicationInformationForm';

interface IProps {
  className?: string;
}

const MedicationInquiryDetails: FC<IProps> = (props: IProps): JSX.Element => {
  const { className = '' } = props;
  return (
    <Box className={cn('admin-supplement-inquiry-details', className)}>
      <DetailsAtTop />
      <MedicationInformationForm />
    </Box>
  );
};

export default MedicationInquiryDetails;
